/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, when: NonNullable<unknown> }} Landing_Team_BookInputs */

const en_landing_team_book = /** @type {(inputs: Landing_Team_BookInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Book ${i?.name}, ${i?.when}`)
};

const pl_landing_team_book = /** @type {(inputs: Landing_Team_BookInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zarezerwuj ${i?.name}, ${i?.when}`)
};

/**
* | output |
* | --- |
* | "Book {name}, {when}" |
*
* @param {Landing_Team_BookInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const landing_team_book = /** @type {((inputs: Landing_Team_BookInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Team_BookInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_landing_team_book(inputs)
	return en_landing_team_book(inputs)
});